import { FormSegmentedButton } from '@ipfabric/ui-components/FormSegmentedButton/FormSegmentedButton';
import { FormTextArea } from '@ipfabric/ui-components/FormTextArea/FormTextArea';
import { FormTextField } from '@ipfabric/ui-components/FormTextField/FormTextField';
import { SegmentButton } from '@ipfabric/ui-components/SegmentedButton/SegmentButton/SegmentButton';
import type { SiteSeparationAttributeTransformation } from '@ipfabric/utils/schema/siteSeparation/siteSeparationAttributeTransformation';
import { RegexSiteNameField } from './RegexSiteNameField';
import {
  REGEX_TOOLTIP_TEXT,
  type RuleEditorContentProps,
  type RuleEditorValues,
  TRANSFORMATION_OPTIONS,
} from './RuleEditor.types';

const HOSTNAME_TRANSFORMATION_TOOLTIP =
  'Transform hostname before matching the regular expression and generating site name. For example, expression "(X.*)_.*" with transform "UPPER CASE" will match hostname "xa_11" into site "XA", while with "lower case" or "none" it won\'t match that hostname at all.';

export const HostnameRuleEditorContent = ({
  control,
}: RuleEditorContentProps) => (
  <>
    <FormSegmentedButton.Single<
      RuleEditorValues,
      SiteSeparationAttributeTransformation
    >
      control={control}
      label='Text transformation (before regular expression match)'
      labelTooltip={HOSTNAME_TRANSFORMATION_TOOLTIP}
      name='transformation'
    >
      {TRANSFORMATION_OPTIONS.map(({ label, value }) => (
        <SegmentButton key={value} value={value} className='flex-1'>
          {label}
        </SegmentButton>
      ))}
    </FormSegmentedButton.Single>
    <FormTextField
      control={control}
      dataTestId='site-separation-regex'
      label='Regular expression'
      labelTooltip={REGEX_TOOLTIP_TEXT}
      name='regex'
      type='text'
    />
    <RegexSiteNameField
      control={control}
      dataTestId='site-separation-sitename'
      label='Site name'
    />
    <FormTextArea
      control={control}
      dataTestId='site-separation-note'
      label='Rule description (optional)'
      name='note'
    />
  </>
);
